export default "__VITE_ASSET__BoQT1c8c__"